<!-- FATURAMENTO = nota de venda autorizada. O link abre a lista de notas no MESMO recorte (período,
     canal, autorizada, venda) e o "Valor total" de lá bate com este número: as duas contam pela emissão
     (IssuedAt ?? CreatedAt) e a Autorizada exclui a cancelada. -->
<a class="kpi-item text-decoration-none" data-kpi="revenue" [class.placeholder-glow]="loading"
  *appHasPermission="roles.INVOICE" routerLink="/notas-fiscais" [queryParams]="links.invoices">
  <span class="stat-label">Faturamento</span>
  <!-- flex-wrap + sem truncate: reticências em dinheiro comem o dígito que decide a ordem de
       grandeza. A variação desce uma linha; o número aparece inteiro. -->
  <div class="d-flex align-items-baseline flex-wrap gap-2 mt-1">
    @if (!loading) {
      <span class="stat-value" [ngbTooltip]="revenueTip || null">{{ compact(kpis?.revenue ?? 0) }}</span>
      @if (revenueVariation; as v) {
        <span class="stat-delta" [ngClass]="v.class" ngbTooltip="Variação sobre o período anterior">
          <i class="ti {{ v.icon }}"></i>{{ v.value > 0 ? '+' : '' }}{{ v.value }}%
        </span>
      }
    } @else {
      <span class="stat-value w-50"><span class="placeholder rounded col-12"></span></span>
    }
  </div>
  <span class="stat-caption mt-1">{{ revenueCaption }} <i class="ti ti-arrow-right ti-xs kpi-go"></i></span>
</a>

<!-- PEDIDOS = pedidos do período (todos, como a lista conta). -->
<a class="kpi-item text-decoration-none" data-kpi="orders" [class.placeholder-glow]="loading"
  *appHasPermission="roles.ORDER" routerLink="/pedidos" [queryParams]="links.orders">
  <span class="stat-label">Pedidos</span>
  <div class="d-flex align-items-baseline flex-wrap gap-2 mt-1">
    @if (!loading) {
      <span class="stat-value">{{ kpis?.orders ?? 0 }}</span>
      @if (ordersVariation; as v) {
        <span class="stat-delta" [ngClass]="v.class" ngbTooltip="Variação sobre o período anterior">
          <i class="ti {{ v.icon }}"></i>{{ v.value > 0 ? '+' : '' }}{{ v.value }}%
        </span>
      }
    } @else {
      <span class="stat-value w-25"><span class="placeholder rounded col-12"></span></span>
    }
  </div>
  <span class="stat-caption mt-1">{{ ordersCaption }} <i class="ti ti-arrow-right ti-xs kpi-go"></i></span>
</a>

<!-- CONTRIBUIÇÃO: com custo em 80% ou mais das vendas, o valor após o custo; senão "Antes do custo".
     Margem indisponível troca o número pela mensagem. -->
<a class="kpi-item text-decoration-none" data-kpi="contribution" [class.placeholder-glow]="loading || !contribution"
  *appHasPermission="roles.ORDER" routerLink="/conciliacao-financeira" [queryParams]="links.reconciliation">
  <span class="stat-label">{{ contribution?.label ?? 'Contribuição' }}</span>
  <div class="d-flex align-items-baseline flex-wrap gap-2 mt-1">
    @if (!loading && contribution; as c) {
      @if (c.unavailable) {
        <span class="stat-value kpi-muted">—</span>
      } @else {
        <span class="stat-value" [class.text-danger]="c.danger">{{ compact(c.value) }}</span>
        @if (c.percent !== null) {
          <span class="kpi-suffix" [class.text-danger]="c.danger">{{ c.percent }}%</span>
        }
      }
    } @else {
      <span class="stat-value w-50"><span class="placeholder rounded col-12"></span></span>
    }
  </div>
  @if (!loading && contribution; as c) {
    <span class="stat-caption mt-1">{{ c.unavailable ?? c.caption }} <i class="ti ti-arrow-right ti-xs kpi-go"></i></span>
  }
</a>

<!-- REPASSE LÍQUIDO: o que o Mercado Pago paga ao vendedor. Só conta canais com conferência de repasse. -->
<a class="kpi-item text-decoration-none" data-kpi="payout" [class.placeholder-glow]="loading || !payout"
  *appHasPermission="roles.ORDER" routerLink="/conciliacao-financeira" [queryParams]="links.reconciliation">
  <span class="stat-label">Repasse líquido</span>
  <div class="d-flex align-items-baseline flex-wrap gap-2 mt-1">
    @if (!loading && payout; as p) {
      @if (p.applies) {
        <span class="stat-value">{{ compact(summary?.paymentsNet ?? 0) }}</span>
      } @else {
        <span class="stat-value kpi-muted">—</span>
      }
    } @else {
      <span class="stat-value w-50"><span class="placeholder rounded col-12"></span></span>
    }
  </div>
  @if (!loading && payout; as p) {
    <span class="stat-caption mt-1">{{ p.caption }} <i class="ti ti-arrow-right ti-xs kpi-go"></i></span>
    @if (p.onlyMercadoLivre) {
      <span class="stat-caption kpi-only" ngbTooltip="Os outros canais não têm conferência de repasse.">Só Mercado Livre</span>
    }
  }
</a>
